import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconSharedModule } from './../../atoms/entry';
import { SubNavSharedComponent } from './sub.nav.component';
import { NavDropdownSharedModule } from '../nav.dropdown/entry';

@NgModule({
    declarations: [
        SubNavSharedComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        IconSharedModule,
        NavDropdownSharedModule
    ],
    exports: [
        SubNavSharedComponent
    ]
})

export class SubNavSharedModule {}
